import { useState } from 'react';

import { FEN_STARTING_POSITION } from '@libs/chess/constants';
import { cx } from '@libs/classnames';
import { useClickOutside } from '@libs/hooks/useClickOutside';
import { useOnEscape } from '@libs/hooks/useOnKeyDown';

import { Button, PositionEditor } from '@features/game/ui/PopupControls';
import stylesControls from '@features/game/ui/PopupControls/PopupControls.module.css';

import { useSettingsMQ } from '../../pages/ComputerGamePage/components/ComputerSettings/useSettingsMQ';

import styles from './PositionEditorModal.module.css';

type Props = {
  className?: string;
  initialFen?: string;
  hideFenInput?: boolean;
  onClose?: () => void;
  onApply?: (fen: string) => void;
};

export function PositionEditorModal({
  className,
  initialFen = FEN_STARTING_POSITION,
  hideFenInput,
  onClose,
  onApply,
}: Props) {
  const ref = useClickOutside<HTMLDivElement>(onClose);
  useOnEscape(onClose);

  const { isMobile } = useSettingsMQ();
  const [fen, setFen] = useState<string | undefined>(initialFen);
  const [isFenTextOpen, setIsFenTextOpen] = useState(false);

  const handleFenChange = (newFen?: string) => {
    setFen(newFen);
  };

  const handleApply = () => {
    if (fen) {
      onApply?.(fen);
    }
  };

  const showButtons = !isMobile || !isFenTextOpen;

  return (
    <div
      className={cx(
        styles.popup,
        stylesControls.container,
        {
          [styles.is_mobile]: isMobile,
          [stylesControls.is_mobile]: isMobile,
        },
        className,
      )}
      ref={ref}
    >
      <PositionEditor
        fen={fen}
        isMobile={isMobile}
        onChange={handleFenChange}
        onFenToggled={setIsFenTextOpen}
        hideFenInput={hideFenInput}
      />

      {showButtons && (
        <div className={styles.buttons}>
          <Button onClick={handleApply} disabled={!fen}>
            Применить
          </Button>
          <Button ghost onClick={onClose}>
            Отменить
          </Button>
        </div>
      )}
    </div>
  );
}
